import type { Locale } from "./locales";
import type { UiStrings } from "./types";
import { en } from "./strings/en";
import { es } from "./strings/es";
import { pt } from "./strings/pt";
import { fr } from "./strings/fr";
import { de } from "./strings/de";
import { ja } from "./strings/ja";
import { hi } from "./strings/hi";
import { zh } from "./strings/zh";
import { ko } from "./strings/ko";
import { id } from "./strings/id";

export const STRINGS: Record<Locale, UiStrings> = { en, es, pt, fr, de, ja, hi, zh, ko, id };

export * from "./locales";
export type { UiStrings } from "./types";
